export default __webpack_public_path__ + "static/kindergarten-readiness9-aa920735660ae24342096c5126b8fbf1.jpg";